// extracted by mini-css-extract-plugin
export default {"page":"page_page__fw8P0","separator":"page_separator__EX3jd","menu":"page_menu__uClOB","sticky-menu":"page_sticky-menu__WS5Pn"};